import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getImageUrl, getUserPublicProfile } from '../services/api';
import './Home.css';

const cleanText = (text) => {
  if (!text) return '';
  return String(text)
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&');
};

const WorkDetail = ({ language }) => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [author, setAuthor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJob();
  }, [code]);

  const fetchJob = async () => {
    try {
      setLoading(true);
      const API_URL = process.env.REACT_APP_API_URL || 'https://www.kapussta.com/api';
      const response = await fetch(`${API_URL}/job/${code}`);
      if (response.ok) {
        const data = await response.json();
        setJob(data);

        if (data.CREATED_BY) {
          try {
            const authorRes = await getUserPublicProfile(data.CREATED_BY);
            setAuthor(authorRes.data);
          } catch (e) {
            console.error('Error fetching author:', e);
          }
        }
      } else {
        navigate('/work');
      }
    } catch (error) {
      console.error('Error fetching job:', error);
      navigate('/work');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!job) {
    return (
      <div className="main">
        <div className="workBlock mainpage">
          <div className="container workcont">
            <div style={{ padding: '50px', textAlign: 'center' }}>
              <h2>Вакансия не найдена</h2>
              <Link to="/work">Вернуться к списку</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main">
      <div className="workBlock mainpage">
        <div className="container workcont">
          {author && (
            <div className="author-header" style={{ marginBottom: '20px', padding: '15px', background: '#fff', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center' }}>
              <Link to={`/profile/${author.id || author.ID}`} style={{ display: 'flex', alignItems: 'center', gap: '15px', textDecoration: 'none', color: 'inherit', width: '100%' }}>
                <div style={{ width: '50px', height: '50px', borderRadius: '50%', overflow: 'hidden', background: '#f0f0f0', flexShrink: 0 }}>
                  {author.avatar ? (
                    <img src={getImageUrl(author.avatar)} alt={author.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#8e44ad', color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>
                      {(author.name || author.NAME || author.login || author.LOGIN || '?').charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#333' }}>{author.name || author.NAME || author.login || author.LOGIN}</h3>
                  <span style={{ fontSize: '14px', color: '#8e44ad', fontWeight: '500' }}>Смотреть профиль агентства</span>
                </div>
              </Link>
            </div>
          )}
          <div className="row">
            <div className="big" style={{ width: '100%', maxWidth: '1200px', margin: '0 auto' }}>
              <div className="bigWork news-detail">
                {job.PREVIEW_PICTURE_SRC && (
                  <div className="image">
                    <img src={getImageUrl(job.PREVIEW_PICTURE_SRC)} alt={job.NAME} />
                  </div>
                )}
                <div className="content">
                  <div className="title">
                    <h3>{job.NAME}</h3>
                  </div>
                  {job.PROPERTIES?.PRICE?.VALUE && (
                    <div className="cost" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <img src="/local/templates/kapussta/img/doll.svg" alt="$" style={{ width: '18px', height: '18px' }} />
                      <p dangerouslySetInnerHTML={{ __html: cleanText(job.PROPERTIES.PRICE.VALUE) }} style={{ margin: 0 }} />
                    </div>
                  )}

                  {job.DETAIL_TEXT && (
                    <div className="opis" style={{ marginTop: '20px' }}>
                      <div dangerouslySetInnerHTML={{ __html: cleanText(job.DETAIL_TEXT) }} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="btnAll" style={{ marginTop: '40px' }}>
            <Link to="/work">← Вернуться к списку</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkDetail;


